/* eslint-disable indent */
import React, {useCallback, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {
  MainLoader,
  DataGrid,
  // , ConfirmationModalPromise
} from '@components';
import {StyledH3, WhiteButton, GreenButton} from '@styled';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import styled from 'styled-components';
import moment from 'moment';
import {SHOW_REPORT_STATUSES} from '@app/utils/constants';
import {sagaActions} from './redux/saga';

const StyledHeadRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .heading {
  }
  .actions {
  }
`;

const RowActions = ({data, onAction}) => {
  return (
    <div>
      <WhiteButton
        onClick={() => onAction('review', data)}
        style={{margin: '.16em'}}
      >
        {/* <i className="fa fa-edit mr-1" /> */}
        Review
      </WhiteButton>
    </div>
  );
};

const RecentlyAddedReports = () => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const remoteData = useSelector(
    (state) => state.validators.recentlyAddedReports
  );
  const isLoading = useSelector(
    (state) => state.validators.recentlyAddedReports.loading
  );
  const history = useHistory();

  const [pagination, setPagination] = React.useState({
    page: 1,
    pageSize: 10,
    totalCount: 0,
    sortOn: 'submittedOn',
    sortDir: 'DESC',
  });

  useEffect(() => {
    if (
      remoteData.page !== pagination.page ||
      remoteData.pageSize !== pagination.pageSize ||
      remoteData.totalCount !== pagination.totalCount ||
      remoteData.sortOn !== pagination.sortOn ||
      remoteData.sortDir !== pagination.sortDir
    ) {
      setPagination({
        page: remoteData.page,
        pageSize: remoteData.pageSize,
        totalCount: remoteData.totalCount,
        sortOn: remoteData.sortOn,
        sortDir: remoteData.sortDir,
      });
    }
  }, [remoteData]);

  const fetchData = ({
    page = 1,
    pageSize = pagination.pageSize,
    sortOn,
    sortDir,
  }) => {
    dispatch({
      type: sagaActions.FETCH_RECENTLY_ADDED_REPORTS,
      payload: {
        values: {
          page,
          pageSize,
          sortOn,
          sortDir,
        },
      },
    });
  };

  const handleRowAction = useCallback((action, row) => {
    switch (action) {
      case 'review': {
        history.push(`/validators/reports/review/${row.id}`, row);
        break;
      }
      default:
        break;
    }
  }, []);

  const renderRowActions = (colProps) => {
    return <RowActions data={colProps} onAction={handleRowAction} />;
  };

  const Columns = React.useMemo(
    () => [
      {
        accessor: 'id',
        Header: 'Report ID',
        className: 'grey-column d-none d-lg-block',
        width: 50,
        tooltip: false,
      },
      {
        accessor: 'corporateName',
        Header: 'Corporate Name',
        tooltip: false,
        className: 'd-none d-lg-block',
      },
      {
        accessor: 'submittedOn',
        Header: 'Submitted On',
        tooltip: false,
        className: 'd-none d-lg-block',
        Cell: ({value}) => (value ? moment(value).format('DD/MM/YYYY') : ''),
      },
      {
        accessor: 'status',
        Header: 'Status',
        tooltip: false,
        className: 'd-none d-lg-block',
        Cell: ({value}) => SHOW_REPORT_STATUSES[value] || value,
      },
      {
        accessor: 'executiveReporter',
        Header: 'Executive Reporter',
        tooltip: false,
        className: 'd-none d-lg-block',
      },

      {
        id: 'actions',
        Header: <div className="d-none d-lg-block">Actions</div>,
        accessor: renderRowActions,
        disableSortBy: true,
        disableFilters: true,
        width: 50,
      },
    ],
    [pagination]
  );

  const handleSeeMore = () => {
    history.push('/validators/reports');
  };

  return (
    <>
      {isLoading && (
        <MainLoader
          minHeight="100vh"
          spinnerColor="#479541"
          background="rgba(0,0,0,0.2)"
        />
      )}
      <div className="card p-2">
        <StyledHeadRow>
          <StyledH3>
            {t('owner.validators.recentlyAddedReports.pageHeading')}
          </StyledH3>
        </StyledHeadRow>
        <DataGrid
          columns={Columns}
          data={remoteData.data}
          onFetchData={fetchData}
          showPagination={false}
          pagination={pagination}
          filtering={false}
          expandEnabled={false}
        />
        <div className="mb-3 text-right">
          <GreenButton onClick={handleSeeMore} size="sm">
            View all
          </GreenButton>
        </div>
      </div>
    </>
  );
};

export default RecentlyAddedReports;
